import React from "react";
import { BarChart3 } from "lucide-react";
import { Reveal } from "../lib/motion";

const CASES = ["Case study 01", "Case study 02", "Case study 03"];

export const CaseStudies = () => {
  return (
    <section className="relative py-[clamp(64px,9vw,120px)]" data-testid="cases-section">
      <div className="container-pm">
        <Reveal className="text-center mb-14">
          <p className="eyebrow mb-4">Transparentność</p>
          <h2 className="font-display font-semibold text-white text-[clamp(34px,4.4vw,58px)] leading-[1.02] tracking-[-0.035em]">
            Realne wyniki. <span className="text-coral">Nie obietnice.</span>
          </h2>
        </Reveal>

        <div className="grid md:grid-cols-3 gap-5">
          {CASES.map((c, i) => (
            <Reveal key={c} delay={i * 0.1}>
              <div className="relative rounded-2xl border border-dashed border-coral/30 bg-graphite/40 p-10 text-center min-h-[220px] flex flex-col items-center justify-center gap-4">
                <BarChart3 className="text-coral/70" size={30} strokeWidth={1.4} />
                <div className="font-display uppercase tracking-[0.2em] text-sm text-white/80">{c}</div>
                <div className="text-xs uppercase tracking-[0.16em] text-gold">Dane po akceptacji</div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal className="text-center">
          <p className="mt-8 text-sm text-white/45">
            Pełne case studies udostępniamy po rozmowie i podpisaniu NDA.
          </p>
        </Reveal>
      </div>
    </section>
  );
};
